import beneficiaryLookupService from '@/services/beneficiary-lookup.service.js'
import * as arcService from '@/services/arc-api.service';
import * as plansService from '@/services/plans-api.service';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { v4 as uuidv4 } from 'uuid';
import router from '@/router'
import {
    NEW_AUTHORIZATION_SET_TYPE,
    NEW_AUTHORIZATION_SET_SPONSOR,
    NEW_AUTHORIZATION_SET_SPONSOR_FORM,
    NEW_AUTHORIZATION_ERROR,
    SET_SPONSOR_SEARCH_METHOD,
    SET_INPUTS_SPONSOR_SEARCH_VALUES,
    AUTHORIZATIONS_ERROR,
    AUTHORIZATIONS_SUCCESS,
    AUTHORIZATONS_LOADING,
    BENEFICIARIES_SUCCESS,
    SET_BENEFICIARY_SELECTED,
    SET_BENEFICIARY_SELECTION,
    COMPLETE_TYPE_STEP,
    COMPLETE_SPONSOR_STEP,
    COMPLETE_METHOD_STEP,
    COMPLETE_BENEFICIARY_STEP,
    COMPLETE_BENEFICIARY_SEARCH,
    SET_BENEFICIARY,
    FIND_BENEFIRIARY_ERROR,
    SET_OUTPATIENT_CARE_FORM,
    SET_BIOMETRIC_VERIFICATION_RESULT,
    SET_LOADING_VERIFICATION,
    SET_LOADING_CREATE_CLAIM,
    SET_CREATE_CLAIM_ERROR,
    SET_NAVBAR_TYPE,
    CLEAR_NEW_AUTHORIZATION,
    SET_CREATE_CLAIM_RESULT
} from '../mutation-types';

const cancelNewAuthorization = ({commit}) =>{
    commit(CLEAR_NEW_AUTHORIZATION)
}

const cleanNewAuthorizationSteps = ({dispatch}) =>{
    dispatch('completeSponsorStep', false)
    dispatch('completeMethodStep', false)
    dispatch('completeBeneficiaryStep', false)
    dispatch('completeBeneficiarySearch', false)
}

const completeAuthorizationTypeStep = ({ commit }, payload) => {
    commit(COMPLETE_TYPE_STEP, payload)
}

const completeSponsorStep = ({ commit }, payload) => {
    commit(COMPLETE_SPONSOR_STEP, payload)
}

const completeMethodStep = ({ commit }, payload) => {
    commit(COMPLETE_METHOD_STEP, payload)
}

const completeBeneficiaryStep = ({ commit }, payload) => {
    commit(COMPLETE_BENEFICIARY_STEP, payload)
}

const completeBeneficiarySearch = ({commit}, payload) => {
    commit(COMPLETE_BENEFICIARY_SEARCH, payload)
}

const setAuthorizationType = ({ commit }, payload) => {
    commit(NEW_AUTHORIZATION_SET_TYPE, payload)
}

const setAuthorizationSponsor = ({commit}, payload) => {
    commit(NEW_AUTHORIZATION_SET_SPONSOR, payload)
}

const getSponsorForm = async ({ commit }, payload) => {
    try{
        const response = await beneficiaryLookupService.getSponsorForm(payload);
        const data = camelizeKeys(response.data)
        commit(NEW_AUTHORIZATION_SET_SPONSOR_FORM, data)
    } catch (error) {
        commit(NEW_AUTHORIZATION_ERROR, error)
    }
}

const setSponsorSearchMethod = ({ commit }, payload) => {
    commit(SET_SPONSOR_SEARCH_METHOD, payload)
}

const setInputSponsorSearchValues = ({ commit }, payload) => {
    commit(SET_INPUTS_SPONSOR_SEARCH_VALUES, payload)
}

const getBeneficiaries = async ({ commit, state, rootState }) => {
    commit(AUTHORIZATONS_LOADING, true)
    commit(AUTHORIZATIONS_ERROR, false)
    commit(COMPLETE_BENEFICIARY_SEARCH, false)
    commit(BENEFICIARIES_SUCCESS, {})
    try{
        const requestValues = state.newAuthorization.beneficiarySearch;
        const providerSlug = rootState.auth.tokenExtensions.providerSlug;

        const request = decamelizeKeys({ 
            formSlug: requestValues.formSlug,
            providerSlug, 
            inputs: requestValues.inputs
        });

        const payload = {
            request: request,
            sponsorSlug: requestValues.sponsorSlug
        };

        const response = await beneficiaryLookupService.getBeneficiaries(payload)
        let data = camelizeKeys(response)
        
        if(data.status === 202 || data.status === 200){            
            if(data.headers.location){

                let monitor = await beneficiaryLookupService.getBeneficiaryMonitor(data.headers.location)                
                if(monitor.data.status === 'ERROR'){
                    throw monitor.data
                }

                commit(BENEFICIARIES_SUCCESS, camelizeKeys(monitor.data))
                commit(AUTHORIZATONS_LOADING, false)    
                commit(COMPLETE_BENEFICIARY_SEARCH, true)

            }
            else{
                throw data
            }

        }else{
            throw 'The search beneficiary response status is unknown'
        }
        
    }catch(error){
        commit(AUTHORIZATIONS_ERROR, true)
        commit(AUTHORIZATONS_LOADING, false)
        commit(COMPLETE_BENEFICIARY_SEARCH, true)       
    }
}

const setBeneficiarySuccess = ({commit}, payload) =>{
    commit(BENEFICIARIES_SUCCESS, payload)
}

const setBeneficiarySelected = ({ commit }, payload) => {
    commit(SET_BENEFICIARY_SELECTED, payload)
}

const setBeneficiarySelection = ({ commit }, payload) => {
    commit(SET_BENEFICIARY_SELECTION, payload)
}

const getAuthorizations = async ({ commit, rootGetters }, filters) => {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    commit(AUTHORIZATONS_LOADING, true)
    try {
        const response = await arcService.getAuthorizations(providerSlug, filters);
        commit(AUTHORIZATIONS_SUCCESS, camelizeKeys(response.data))
        commit(AUTHORIZATONS_LOADING, false)
    } catch (error) {
        commit(AUTHORIZATIONS_ERROR, error)
        commit(AUTHORIZATONS_LOADING, false)
    }      
};

const getBeneficiary = async ({ commit, state }) => {
    const beneficiarySelectedId = state.beneficiarySelected.id || '';

    try {
        const response = await plansService.getBeneficiary(beneficiarySelectedId)
        commit(SET_BENEFICIARY, camelizeKeys(response.data))
        commit(FIND_BENEFIRIARY_ERROR, false)
    } catch (error) {
        commit(FIND_BENEFIRIARY_ERROR, true)
    }
}

const setOutpatientCareForm = ({ commit }, payload) => {
    commit(SET_OUTPATIENT_CARE_FORM, payload)
}

const setNavBarType = ({commit}, payload) => {
    commit(SET_NAVBAR_TYPE, payload)
}

const verifyBiometric = async ({ commit, state, rootState }, payload) => {
    commit (SET_LOADING_VERIFICATION, true)
    commit(SET_BIOMETRIC_VERIFICATION_RESULT, null)
    const beneficiarySelectedId = state.beneficiarySelected.id || '';
    const providerSlug = rootState.auth.tokenExtensions.providerSlug;

    const body = {
        beneficiaryId: beneficiarySelectedId,
        type: payload.type,
        value: payload.value
    }

    try {
        const response = await arcService.sendBiometricValidation(providerSlug, body)
        const result = camelizeKeys(response.data)
        commit(SET_BIOMETRIC_VERIFICATION_RESULT, result)
        commit (SET_LOADING_VERIFICATION, false)
    } catch (error) {
        commit(SET_BIOMETRIC_VERIFICATION_RESULT, { verificationStatus: 'ERROR' })
        commit (SET_LOADING_VERIFICATION, false)
    }
}

const startClaimAuthorization = async ({ commit, state, rootState }) => {
    commit(SET_LOADING_CREATE_CLAIM, true)
    const beneficiaryId = state.beneficiarySelected.id || '';
    const providerSlug = rootState.auth.tokenExtensions.providerSlug;
    const sponsorSlug = state.newAuthorization.beneficiarySearch.sponsorSlug;
    const productCode = state.outpatientCareForm.doctorFields.productCode || '1';
    const beneficiaryCategory = state.outpatientCareForm.beneficiaryFields.sponsorCategory || null;

    const sponsorParameters = { productCode, beneficiaryCategory }

    const body = {
        beneficiaryId,
        sponsorSlug,
        providerTransactionId: uuidv4(),
        sponsorParameters
    }

    try {
        const response = await arcService.startClaimAuthorization(providerSlug, body)
        if (response.status === 202) {
            const location = response.headers.location
            if (location) {
                const monitor = await arcService.getClaimProcessMonitor(location)
                if (monitor.data.status === 'ERROR') {
                    throw monitor.data
                }
                const monitorData = camelizeKeys(monitor.data)
                const diagnoses = [{code: 'Z00.0', codingSystem: 'ICD-10'}]
                const { license: doctorMedicalLicenseNumber, country: doctorCountryCode,
                specialty: doctorSpecialtyName, name: doctorName } = state.outpatientCareForm.doctorFields
                const { id: biometricReadingId } = state.biometricVerificationResult
                const completeClaimBody = {
                    biometricReadingId, doctorMedicalLicenseNumber, doctorCountryCode, doctorSpecialtyName,
                    doctorName, diagnoses
                }
                await arcService.completeClaimAuthorization(providerSlug, monitorData.id, completeClaimBody)
                commit(SET_CREATE_CLAIM_RESULT, 'SUCCESS')
                commit(CLEAR_NEW_AUTHORIZATION)
                router.push('/home')
            }
        }
        commit (SET_LOADING_CREATE_CLAIM, false)
    } catch (error) {
        commit(SET_CREATE_CLAIM_RESULT, 'ERROR')
        commit(SET_CREATE_CLAIM_ERROR, error)
        commit(SET_LOADING_CREATE_CLAIM, false)
        commit(CLEAR_NEW_AUTHORIZATION)
        router.push('/home')
    }
}

const setCreateClaimResult = ({commit}, payload) => {
    commit(SET_CREATE_CLAIM_RESULT, payload)
}


export default {
    setAuthorizationType,
    setAuthorizationSponsor,
    getSponsorForm,
    setSponsorSearchMethod,
    setInputSponsorSearchValues,
    getBeneficiaries,
    getAuthorizations,
    setBeneficiarySuccess,
    setBeneficiarySelected,
    setBeneficiarySelection,
    completeAuthorizationTypeStep,
    completeSponsorStep,
    completeMethodStep,
    completeBeneficiaryStep,
    cleanNewAuthorizationSteps,
    completeBeneficiarySearch,
    getBeneficiary,
    setOutpatientCareForm,
    verifyBiometric,
    startClaimAuthorization,
    setNavBarType,
    cancelNewAuthorization,
    setCreateClaimResult
}